import { ShieldCheck } from "lucide-react";

export default function TrustSection() {
  return (
    <section className="bg-gradient-to-br from-indigo-700 via-indigo-600 to-cyan-600 py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <ShieldCheck className="h-10 w-10 text-white/80 mx-auto mb-6" />
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-6">
          Your Career Is Bigger Than a Single Test Score.
        </h2>
        <p className="text-base sm:text-lg text-indigo-50/90 leading-relaxed">
          Academic results matter, but they are only one part of the story. CareerStudy360 looks across multiple
          dimensions to understand how your interests, abilities, preferences, strengths and motivations come
          together. The purpose is not to place you inside one box — it is to help you explore the professional
          environments and career possibilities where your combination of characteristics may have the greatest
          opportunity to grow.
        </p>
      </div>
    </section>
  );
}
